import { outboundLegacyRoute } from './OutboundLegacyRoute';

export const legacyUserSettingsUrl = '#/account';

export const LegacyDiscoverGroups = outboundLegacyRoute('#/groups');
export const LegacyGroupSettings = outboundLegacyRoute('#/groups/:groupId/settings');
export const LegacyGroupDelete = outboundLegacyRoute('#/groups/:groupId/delete');
export const LegacyCreateGroup = outboundLegacyRoute('#/create_group');
export const LegacyGroupFiles = outboundLegacyRoute('#/groups/:groupId/files');
export const LegacyGroupInsights = outboundLegacyRoute('#/groups/:groupId/insights');
export const LegacyUserSettings = outboundLegacyRoute(legacyUserSettingsUrl);
export const LegacyGroupInfo = outboundLegacyRoute('#/groups/:groupId/info');
export const LegacyNetworkAdminSettings = outboundLegacyRoute('admin');
